/* Exportação de listagens para CSV e PDF.
 * columns: [{ key, label, format?: (value, row) => string }]
 */
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function cellValue(col, row) {
  const raw = col.format ? col.format(row[col.key], row) : row[col.key];
  if (raw == null) return "";
  // Intl pt-BR usa NBSP em moedas — normaliza p/ espaço comum (Excel/PDF)
  return String(raw).replace(/\u00A0/g, " ");
}

export function exportCSV(filename, columns, rows) {
  const esc = (s) => (/[";\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s);
  const header = columns.map((c) => esc(c.label)).join(";");
  const lines = rows.map((r) => columns.map((c) => esc(cellValue(c, r))).join(";"));
  const csv = "\uFEFF" + [header, ...lines].join("\n"); // BOM p/ acentos no Excel
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export function exportPDF(title, filename, columns, rows, opts = {}) {
  const doc = new jsPDF({ orientation: opts.orientation || "landscape" });
  doc.setFontSize(14);
  doc.setFont(undefined, "bold");
  doc.text(title, 14, 16);
  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.setTextColor(120);
  doc.text(`Gerado em ${new Date().toLocaleString("pt-BR")} · Portal Zemo · ${rows.length} registro(s)`, 14, 22);
  autoTable(doc, {
    startY: 27,
    head: [columns.map((c) => c.label)],
    body: rows.map((r) => columns.map((c) => cellValue(c, r) || "—")),
    styles: { fontSize: 8, cellPadding: 2.5 },
    headStyles: { fillColor: [0, 85, 255], textColor: 255, fontStyle: "bold" },
    alternateRowStyles: { fillColor: [246, 247, 249] },
  });
  doc.save(filename.endsWith(".pdf") ? filename : `${filename}.pdf`);
}
